"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.GHGProducingBacteria = void 0;
var Tags_1 = require("../Tags");
var Card_1 = require("../Card");
var CardType_1 = require("../CardType");
var OrOptions_1 = require("../../inputs/OrOptions");
var ResourceType_1 = require("../../ResourceType");
var SelectOption_1 = require("../../inputs/SelectOption");
var CardName_1 = require("../../CardName");
var LogHelper_1 = require("../../LogHelper");
var CardRequirements_1 = require("../CardRequirements");
var CardRenderer_1 = require("../render/CardRenderer");
var GHGProducingBacteria = (function (_super) {
    __extends(GHGProducingBacteria, _super);
    function GHGProducingBacteria() {
        var _this = _super.call(this, {
            cardType: CardType_1.CardType.ACTIVE,
            name: CardName_1.CardName.GHG_PRODUCING_BACTERIA,
            tags: [Tags_1.Tags.SCIENCE, Tags_1.Tags.MICROBE],
            cost: 8,
            resourceType: ResourceType_1.ResourceType.MICROBE,
            requirements: CardRequirements_1.CardRequirements.builder(function (b) { return b.oxygen(4); }),
            metadata: {
                description: 'Requires 4% oxygen.',
                cardNumber: '034',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.action('Add 1 Microbe to this card.', function (eb) {
                        eb.empty().startAction.microbes(1);
                    }).br;
                    b.or().br;
                    b.action('Remove 2 Microbes to raise temperature 1 step.', function (eb) {
                        eb.microbes(2).startAction.temperature(1);
                    });
                }),
            },
        }) || this;
        _this.resourceCount = 0;
        return _this;
    }
    GHGProducingBacteria.prototype.play = function () {
        return undefined;
    };
    GHGProducingBacteria.prototype.canAct = function () {
        return true;
    };
    GHGProducingBacteria.prototype.action = function (player) {
        var _this = this;
        if (this.resourceCount < 2) {
            player.addResourceTo(this, { log: true });
            return undefined;
        }
        var orOptions = new OrOptions_1.OrOptions();
        if (player.canAfford(0, { tr: { temperature: 1 } })) {
            orOptions.options.push(new SelectOption_1.SelectOption('Remove 2 microbes to raise temperature 1 step', 'Remove microbes', function () {
                player.removeResourceFrom(_this, 2);
                LogHelper_1.LogHelper.logRemoveResource(player, _this, 2, 'raise temperature 1 step');
                return player.game.increaseTemperature(player, 1);
            }));
        }
        orOptions.options.push(new SelectOption_1.SelectOption('Add 1 microbe to this card', 'Add microbe', function () {
            player.addResourceTo(_this, { log: true });
            return undefined;
        }));
        if (orOptions.options.length === 1)
            return orOptions.options[0].cb();
        return orOptions;
    };
    return GHGProducingBacteria;
}(Card_1.Card));
exports.GHGProducingBacteria = GHGProducingBacteria;
